/*
 * jBone.widget.scrollSpy
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var device = require('util/device.util');

    require('common/jbone.widget');

    // todo rewrite to IntersectionObserver + ResizeObserver, remove all hardcode
    module.exports = $.widget('scrollSpy', {

        init: function(options) {
            this.setOptions(options);
            this.stickyClassName = 'scrollSpy-fixed';
            this.staticClassName = 'scrollSpy-static';

            this.forceCalculate();

            this.$wrapper && this.$wrapper.addClass(this.staticClassName);

            $(window).on('scroll.scrollSpy', _.throttle(this.handleScroll.bind(this), 50));
            $(window).on('orientationchange.scrollSpy', _.debounce(this.handleResize.bind(this), 100));

            core.listenToOnce(core, 'after:render', this.handleAfterRender.bind(this));

            this.obs = new IntersectionObserver(this.handleIntersectionChange.bind(this));
            this.$wrapper.forEach(function(el) {
                this.obs.observe(el);
            }.bind(this));
        },

        setOptions: function(options) {
            this.$el = options.fixedElement || $('.scrollSpy-fixed');
            this.$wrapper = options.elementWrapper || null;
            this.$elementToStick = options.stickToElement || null;
            this.$stopElement = options.fixToElement && options.fixToElement[0] ? options.fixToElement : null;

            this.direction = options.direction || 'bottom';
            this.currentPosition = options.breakpoint || 0;

            this.toggleStickingHandler =
                _.isFunction(options.toggleStickingHandler) ? options.toggleStickingHandler : null;
            this.getCurrentPosition = _.isFunction(options.checkFunc) ? options.checkFunc : null;
            this.destroyHandler = _.isFunction(options.destroyHandler) ? options.destroyHandler : null;
        },

        handleIntersectionChange: function() {
            this.forceCalculate();
            this.proccessScroll(true);
        },

        calculateStickPosition: function() {
            var smsBannerHeight = $('.sms-banner-container').length ? $('.sms-banner-container').getHeight() : 0;
            this.stickPosition = this.$elementToStick ? this.$elementToStick.getHeight() + smsBannerHeight : 0;
        },

        calculateStopPosition: function() {
            var $stopElement = this.$stopElement;
            var $wrapper = this.$wrapper;
            this.stopPosition = $stopElement.offset().top + $stopElement.getHeight() - $wrapper.getHeight();
        },

        forceCalculate: function() {
            this.calculateStickPosition();
            this.$stopElement && this.calculateStopPosition();
        },

        handleAfterRender: function() {
            this.forceCalculate();
        },

        handleResize: function() {
            this.forceCalculate();
            this.proccessScroll(true);
        },

        handleScroll: function() {
            this.proccessScroll(false);
        },

        toggleSticking: function(isSticked) {
            this.$stopElement && this.toggleFixedToBottom(false);

            this.$el.toggleClass(this.stickyClassName, isSticked);
            this.$wrapper && this.$wrapper.toggleClass(this.staticClassName, isSticked);

            this.toggleStickingHandler && this.toggleStickingHandler(isSticked);
        },

        toggleFixedToBottom: function(isFixed) {
            var $el = this.$el;
            var $wrapper = this.$wrapper;
            var fixedClassName = 'sticky-menu_stop-sticking';

            if (isFixed) {
                var paddingSize = this.stopPosition - $wrapper.offset().top - $wrapper.getHeight();
                $el.css('top', paddingSize + 'px');
                $el.removeClass('scrollSpy-fixed');
            }

            $el.toggleClass(fixedClassName, isFixed);
            this.isFixed = isFixed;
        },

        proccessScroll: function(isForce) {
            this.currentPosition = this.getCurrentPosition ? this.getCurrentPosition() : this.breakpoint;

            if (this.direction === 'top') {
                this.calculateStickPosition();
                this.manageTopDirection(isForce);
            } else {
                this.manageBottomDirection(isForce);
            }
        },

        manageTopDirection: function(isForce) {
            var document = window.document;
            var elementStyles = this.$el[0].style;

            var htmlVerticalScrollSize = document.documentElement.scrollTop;
            var bodyVerticalScrollSize = document.body.scrollTop;

            var isScrolled = Boolean(Math.max(htmlVerticalScrollSize, bodyVerticalScrollSize));

            var scrolledMoreThatStickPosition = this.stickPosition >= this.currentPosition;
            var scrolledLessThatStickPosition = !scrolledMoreThatStickPosition;
            var isSetCustomPosition = this.currentPosition === window.innerHeight + 1;
            var hasStickyClassName = this.$el.hasClass(this.stickyClassName);
            var isNotFixedToElement = !this.isFixed;
            var isSearchActive = $('.fn-search-wrapper.search-activated').length;
            var isDesktop = device.formFactor === 'desktop';
            var scrolledToTheTop = window.scrollY === 0 && hasStickyClassName && !isSearchActive;

            var shouldEnableStick = isSearchActive && !isDesktop || isScrolled && scrolledMoreThatStickPosition && (!hasStickyClassName || isForce);
            var shouldFixedToElement = this.$stopElement && isSetCustomPosition && isNotFixedToElement;
            var shouldDisableStick = scrolledToTheTop || scrolledLessThatStickPosition && isNotFixedToElement && (hasStickyClassName || isForce);
            var marginTop = device.os === 'ios' ? 2 : 0;

            if (shouldEnableStick) {
                this.toggleSticking(true);
                elementStyles.top = this.stickPosition - marginTop + 'px';

            } else if (shouldFixedToElement) {
                this.calculateStopPosition();
                this.toggleFixedToBottom(true);

            } else if (shouldDisableStick) {
                this.toggleSticking(false);
                elementStyles.top = 'auto';
            }
        },

        manageBottomDirection: function(isForce) {
            var isScrolled = window.innerHeight < this.currentPosition;
            var hasStickyClassName = this.$el.hasClass(this.stickyClassName);

            var shouldEnableStick = isScrolled && (!hasStickyClassName || isForce);
            var shouldDisableStick = !isScrolled && (hasStickyClassName || isForce);

            if (shouldEnableStick) {
                this.toggleSticking(true);

            } else if (shouldDisableStick) {
                this.toggleSticking(false);
            }
        },

        destroy: function() {
            $(window).off('scroll.scrollSpy orientationchange.scrollSpy');
            this.$wrapper.forEach(function(el) {
                this.obs.unobserve(el);
            }.bind(this));

            this.destroyHandler && this.destroyHandler();
        }
    });
});
